import * as type from '../type';

export function preProcessedMedicalRecordsData(data) {
  return {
    type: type.PRE_PROCCESSED_MEDICAL_DATA,
    payload: data
  }
}